export default class DaisyMessageFilter {
  messageType: string;

  language: string;

  active: boolean | null;

  constructor(obj: any = {}) {
    this.messageType = obj.messageType || '';
    this.language = obj.language || '';
    this.active = obj.active !== undefined ? obj.active : null;
  }

  get hasMessageType(): boolean {
    return !!this.messageType;
  }

  get hasLanguage(): boolean {
    return !!this.language && !!this.language.trim();
  }

  get hasActive(): boolean {
    return this.active !== null && this.active !== undefined;
  }
}
